<template>
    <div>
        <div v-if="!newForm">
            <div>
                <div class="filter-container">
                    <div class="left-content">
                        <b-dropdown class="filter-dropdown overflow-visible" variant="default" ref="drop">
                            <template #button-content>
                                <span class="lc"><i class="icon icon-filter"></i> {{ setText('filter') }} </span><span class="rc"><i
                                class="icon icon-keyboard"></i></span>
                            </template>
                            <div>
                                <div class="top-content">
                                    <span>{{ setText('filter_params') }}</span>
                                    <i class="icon icon-close" @click="$refs.drop.hide(true)"></i>
                                </div>
                                <div class="filter-block-date-range">
                                    <label class="mr-3">{{ setText('period_from') }}</label>
                                    <date-picker
                                        :placeholder="setText('date_select')"
                                        v-model="dateFromForInput"
                                        format="DD/MM/YYYY"
                                        :append-to-body="false"
                                    />
                                    <label class="mx-3">{{ setText('period_to') }}</label>
                                    <date-picker
                                        :placeholder="setText('date_select')"
                                        v-model="dateToForInput"
                                        format="DD/MM/YYYY"
                                        :append-to-body="false"
                                    />
                                </div>
                                <!---------------------АБП------------------------->
                                <div class="sp-block-alteration">
                                    <div class="filter-block m-0">
                                        <b-form-group :label="setText('abp')" v-if="['abp', 'uf'].includes(accessLevels.position)">
                                            <multiselect
                                                v-model="currAbp"
                                                track-by="localText"
                                                label="localText"
                                                :placeholder="setText('abp_select')"
                                                :options="abpBase"
                                                :searchable="true"
                                                :show-labels="false"
                                                ref="filterAbp"
                                            >
                                            </multiselect>
                                        </b-form-group>
                                    </div>
                                    <!---------------------Регион---------------------->
                                    <div class="filter-block">
                                        <b-form-group :label="setText('obl')">
                                            <multiselect
                                                v-model="currRegion"
                                                label="localText"
                                                :placeholder="setText('region_select')"
                                                :options="regionBase"
                                                :searchable="true"
                                                :allow-empty="false"
                                                :show-labels="false"
                                                ref="filterReg"
                                            />
                                        </b-form-group>
                                    </div>
                                    <!------------------Кнопка------------------------->
                                    <div class="filter-block">
                                        <b-button variant="primary" @click="loadData(year, currRegion, currAbp)">{{ setText('apply') }}</b-button>
                                        <b-button variant="secondary" @click="clearParam">{{ setText('reset') }}</b-button>
                                    </div>
                                    <hr>
                                    <!------------------Вид заявки--------------------->
                                    <div class="filter-block">
                                        <b-form-group :label="setText('request_type')">
                                            <multiselect
                                                v-model="selectedAlteration"
                                                :placeholder="setText('rt_select')"
                                                :options="listAlteration"
                                                track-by="name"
                                                label="name"
                                                :searchable="true"
                                                :allow-empty="false"
                                                :show-labels="false"
                                                ref="refAlteration"
                                            >
                                            </multiselect>
                                        </b-form-group>
                                    </div>
                                    <!------------------Статус------------------------->
                                    <div class="filter-block">
                                        <b-form-group :label="setText('status')">
                                            <multiselect
                                                v-model="selectedStatus"
                                                :placeholder="setText('status_select')"
                                                :options="listStatus"
                                                track-by="name"
                                                label="name"
                                                :searchable="true"
                                                :allow-empty="false"
                                                :show-labels="false"
                                                ref="refStatus"
                                            >
                                            </multiselect>
                                        </b-form-group>
                                    </div>
                                    <!------------------Трансферт------------------------->
                                    <div class="filter-block">
                                        <b-form-group :label="setText('scorr_transf')">
                                            <div class="modal__toggle">
                                                <b-form-checkbox v-model="transfert" switch/>
                                            </div>
                                        </b-form-group>
                                    </div>
                                    <div class="filter-block">
                                        <b-button variant="primary" @click="filterApply">{{ setText('apply') }}</b-button>
                                        <b-button variant="secondary" @click="clearFilter">{{ setText('reset') }}</b-button>
                                    </div>
                                    <hr>
                                </div>
                            </div>
                        </b-dropdown>
                    </div>

                    <div class="right-content">
                        <div class="filter-actions" v-if="levels.length > 1">
                            <b-form-radio-group
                                id="radio-group-1"
                                v-model="level"
                                :options="levels"
                                name="level-options"
                                @change="changeLevel"
                            >
                            </b-form-radio-group>
                        </div>
                        <div class="filter-actions">
                            <b-button v-if="typeForm > 0" :disabled="!accessLevels.editAccess || cDis" variant="primary" @click="modalConsolOpen(null)">
                                <span>{{ setText('consolidate') }}</span>
                            </b-button>
                        </div>
                    </div>
                </div>
            </div>
            <!--  хлебные крошки   -->
            <div class="filter-breadcrumb">
                <span class="item-breadcrumb" v-if="year" @click="openFilterByRef('filterYear')"> {{ year }} </span>
                <span class="item-breadcrumb" v-if="currAbp && !['uf'].includes(accessLevels.position)" @click="openFilterByRef('filterAbp')"> {{ abpDisplayText }}</span>
                <span class="item-breadcrumb" v-if="currRegion" @click="openFilterByRef('filterReg')"> {{ currRegion.localText}} </span>
                <span class="item-breadcrumb" v-if="selectedAlteration" @click="openFilterByRef('refAlteration')"> {{ setText('request_type') }} - {{selectedAlteration.name}} </span>
                <span class="item-breadcrumb" v-if="selectedStatus" @click="openFilterByRef('refStatus')"> {{ setText('status') }} - {{selectedStatus.name}}  </span>
            </div>
            <CRequestsTable
                :requestsBase="requestsBase"
                @onChange="onChange"
                @onOpen="onOpen"
                @onDelete="onDelete"
                @chgData="chgData"
                @onChecked="onChecked"
                @reLoad="onReLoad"
                :levelsCheck="true"
                :requestTypeOptions="requestTypeOptions"
                :accessLevels="accessLevels"
                :activeTab="activeTab"
                :statusType="listStatus"
                :inc-tab="true"
                :edit-access-status-list="typeForm === 0? [1, 27, 38, 69]: [1, 28, 32, 38, 69]"
                :tabIndex="tabIndex"
                :tabCode="tabCode"
                @reload-journal="$emit('reload-journal')"
                :isLoadToJournalEnabled="isLoadToJournalEnabled"
                :isTransfert="transfert"
            />
            <!-- Отображение количества заявок -->
            <div class="requests-count" v-if="requestsBase && requestsBase.length > 0">
                {{ setText('requests_count') }}:  {{ requestsBase.length }}
            </div>
            <div class="requests-count" v-else>
                {{ setText('no_requests_found') }}
            </div>
            <b-modal
                size="lg"
                id="modal-create2"
                v-model="modalForm"
                centered
                hide-header
                hide-footer
            >
                <div class="add_modal">
                    <div class="add_modal__title">
                        {{ setText(modalTitleKey) }}
                    </div>

                    <div class="add_modal__body">
                        <div class="add_modal__item">
                            <div class="add_modal__item__title">№</div>
                            <div class="date-picker-container">
                                <b-form-input
                                    type="number"
                                    :min="1"
                                    class="form-input"
                                    v-model="currentAlteration.number"
                                    :formatter="formatter"
                                    @keypress="keyPress($event, '^\\d*\\d{0,9}$')"
                                    @change="saveFalse = false"
                                    :disabled="!canEditBasisField"
                                />
                                {{ setText('date') }}
                                <date-picker
                                    :placeholder="setText('date_select')"
                                    v-model="curDate"
                                    format = "DD/MM/YYYY"
                                    type="date"
                                    style="max-width: 500px"
                                    :disabled-date="createDateDisabled"
                                    @input="dateChange"
                                    :disabled="!canEditBasisField"
                                />

                            </div>
                        </div>
                        <div class="add_modal__item">
                            <div class="add_modal__item__title">{{ setText('request_type') }}</div>
                            <multiselect
                                v-model="selectedReqType"
                                label="localText"
                                :placeholder="setText('rt_select')"
                                :options="requestTypeList"
                                style="width: 480px"
                                :searchable="true"
                                :allow-empty="false"
                                :show-labels="false"
                                @input="reqTypeClick"
                                ref="filterAbp"
                                :disabled="!canEditBasisField"
                            />
                        </div>
                        <div class="add_modal__item">
                            <div class="add_modal__item__title black">{{ setText('onBased') }}</div>
                            <b-form-input
                                id="textarea"
                                :placeholder="setText('description_add')"
                                type="text"
                                v-model="currentAlteration.description"
                                class="input"
                                style="width: 480px"
                            ></b-form-input>

                        </div>
                        <div class="add_modal__item">
                            <label class="input-file-label"
                            >{{ setText('document_attach') }}</label
                            >
                            <b-form-file v-model="file"
                                         id="fileInput"
                                         accept=".xls, .xlsx, .pdf, .doc, .docx"
                                         placeholder=""
                                         :browse-text = "setText('review')"
                                         @change="syncFile"
                                         size="sm"
                                         style="width: 760px"
                                         :disabled="!canEditBasisField" >
                            </b-form-file>
                        </div>
                        <div class="col-md-12">
                            <table class="table table-striped"
                                   style="font-weight: 600;
                                          font-size: 14px;
                                          color: #6087a0;">
                                <tr v-for="(file, index) in createdAlterationFiles" :key="'index'+index">
                                    <td>{{file.name}}</td>
                                    <td><button class="button button-close"
                                                @click="deletedAlterationFiles.push(file); createdAlterationFiles.splice(index, 1);"
                                                :disabled="!canEditBasisField">x</button>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <div v-if="saveTrue">
                        <p style="color: red;  font-size: 14px;">{{typeName}}</p>
                    </div>
                    <div v-if="saveFalse">
                        <p style="color: red; font-size: 14px;">{{ numberName }}</p>
                    </div>
                    <div class="add_modal__footer">
                        <b-button variant="primary"  @click="saveRequest">{{ setText('save') }}</b-button>
                        <b-button variant="secondary"  @click="onClose">{{ setText('cancel') }}</b-button>
                    </div>
                </div>
            </b-modal>
        </div>
        <div v-if="newForm">
            <new-alteration-form :currentAlteration="currentAlteration"
                                 :currAbp="currAbp"
                                 :currGu="null"
                                 :currRegion="currRegion"
                                 :guBase="guBase"
                                 :listAlteration="listAlteration"
                                 :accessLevel="accessLevels"
                                 :moduleCode="moduleCode"
                                 :mode="mode"
                                 :newRequest="false"
                                 :tableType="1"
                                 @onBack="onBack"
                                 :tab-index="tabIndex"
                                 :tabCode="tabCode"
                                 @reload-journal="$emit('reload-journal')"
                                 :isLoadToJournalEnabled="isLoadToJournalEnabled"
                                 :activeTab="activeTab"
                                 :isTransfert="transfert"
                                 :requestTypeOptions="requestTypeOptions">
            </new-alteration-form>
        </div>
        <loading
            :active="loading"
            is-full-screen
            spinner="bar-fade-scale"
            color="#6495ED"
        />
    </div>
</template>

<script>
import CRequestsTable from "./c-requests-table.vue";
import VueElementLoading from "vue-element-loading";
import newAlterationForm from "@/modules/budget/alteration/form/tabs/components/CreateForm/newAlterationForm";
import DatePicker from "vue2-datepicker";
import store from "@/services/store";
import AlterationI18nMixin from "@/modules/budget/alteration/mixins/alteration-i18n-mixin";
import moment from "moment/moment";
import {clampToPeriod, isOutOfPeriod} from "@/modules/budget/alteration/form/tabs/filter-period";

export default {
    name: "AlterationReferencesABP",
    components: { CRequestsTable, DatePicker, 'loading': VueElementLoading, newAlterationForm },
    mixins: [ AlterationI18nMixin ],
    data() {
        return {
            year: `${new Date().getFullYear()}`,
            selectedAlteration: null,
            selectedStatus: null,
            listStatus: [],
            listAlteration: [],
            loading: false,
            modalForm: false,
            showBr: false,
            selectedReqType: null,
            requestTypeList: [],
            currAbp: null,
            abpBase: [],
            guBase: [],
            guArr: [],
            currRegion: null,
            requestsBase: null,
            requestsData: null,
            userAbp: null,
            files: [],
            currAltStatusEdit: false,
            currentAlteration: {
                id: null,
                number: null,
                gu: null,
                date: new Date(),
                requestType: null,
                budgetVersion: null,
                planType: null,
                requestLevel: null,
                user_id: null,
                create_date: null,
                update_date: null,
                delete_date: null,
                fileList: []
            },
            createdAlterationFiles: [],
            editedAlterationFiles: [],
            deletedAlterationFiles: [],
            newForm: false,
            file: null,
            saveTrue: false,
            saveFalse: false,
            variantBase: [],
            currentVariant: null,
            cDis: true,
            requestStatus: false,
            level: 1,
            levels: [],
            userList: [],
            dateFromForInput: null,
            dateToForInput: null,
            dateFrom: null,
            dateTo: null,
            curDate: new Date(`${new Date()}`),
            lsStatusFilter: 'budget_alteration_tab3_status',
            intgrSettings: false,
            transfert: false,
            factRegionSettings: false
        }
    },
    computed: {
        mode() {
            let i = '';
            if (this.intgrSettings) {
                i = 'i'
            }
            switch (this.typeForm) {
                case 1:
                    return 'exz' + i;
                    break;
                default:
                    return 'exv' + i;
                    break;
            }
        },
        modalTitleKey() {
            return this.requestStatus ? 'edit' : 'create'
        },
        numberName() {
            return this.setText('num_already_exists') + this.currentAlteration.number + this.setText('num_already_exists2');
        },
        typeName() {
            let name = ''
            if (this.currentAlteration.description === null) {
                name = name + this.setText('base');
            }
            if (this.currentAlteration.requestType === null) {
                if (name.length > 0) { name = name + ' , '}
                name = name + this.setText('request_type');
            }
            if (this.currentAlteration.number === '' || this.currentAlteration.number === null) {
                if (name.length > 0) { name = name + ' , '}
                name = name + '"№"';
            }
            return this.setText('required_fields') + name;
        },
        // Проверяем, можно ли редактировать поле "Основание"
        canEditBasisField() {
            // Если это создание новой заявки, то поле доступно для редактирования
            if (!this.requestStatus) {
                return true;
            }

            // При редактировании проверяем статус и консолидацию
            if (this.currentAlteration && this.currentAlteration.status) {
                // Статус "Согласовано УО" (статус 32)
                const isApprovedByUO = this.currentAlteration.status.status === 32;
                // Проверяем, сконсолидирована ли заявка (предполагаем наличие поля parent)
                const isConsolidated = this.currentAlteration.parent !== null;

                // Блокируем редактирование если заявка в статусе 32 И сконсолидирована
                if (isApprovedByUO && isConsolidated) {
                    return false;
                }

                // Во всех остальных случаях разрешаем редактирование
                return true;
            }
            return true;
        },
        abpDisplayText() {
            if (!this.currAbp) return '';
            return this.currAbp.abp === 0 ? this.setText('abp') : `${this.currAbp.abp}-${this.setText('abp')}`;
        }
    },
    async mounted() {
        this.loading = true;
        this.dateFromForInput = moment().startOf('month').toDate();
        this.dateToForInput = moment().endOf('month').toDate();
        this.loading = false;

        if (this.tabIndex === 2) { this.lsStatusFilter = 'budget_alteration_tab2_status'; }
        else { this.lsStatusFilter = 'budget_alteration_tab3_status'; }
    },
    async created() {
        await this.intgrSettingsLoad();
        await this.loadStatusList();
        await this.loadAbpList();
        this.typeListLoad();
        this.currAbp = this.abpBase[0];
        this.selectedAlteration = this.listAlteration[0];
        this.currRegion = this.regionBase[0];

        this.$watch('reLoadChildABP', () => {
            if (this.reLoadChildABP) {
                this.loadData(this.year, this.currRegion, this.currAbp);
                this.$emit('unReLoadChildABP', false);
            }
        });

        await this.getAccessLevel();
        await this.factRegionSettingsLoad();
    },
    watch: {
        // accessLevels: async function(){
        //     await this.getAccessLevel();
        // },
        selectedStatus: function () {
            localStorage[this.lsStatusFilter] = this.selectedStatus.code;
        },
        level: async function () {
            await this.loadAbpList();
            this.typeListLoad();
            await this.loadStatusList();
            this.currAbp = this.abpBase[0];
            this.selectedAlteration = this.listAlteration[0];
            this.currRegion = this.regionBase[0];
            if (this.accessLevels && this.currRegion !== undefined) {
                await this.loadData(this.year, this.currRegion, this.currAbp);
            }
        },
        locale: async function() {
            await this.loadAbpList();
            this.typeListLoad();
            await this.loadStatusList();
        },
        typeForm: function () {
            if (this.typeForm === 0) {this.mode = 'exv'}
            else {
                if (this.typeForm === 1) {this.mode = 'exz'}
            }
        },
        currRegion: function(){
            this.loadData(this.year, this.currRegion, this.currAbp);
        }
    },
    props: ["requestTypeOptions", "userId", "moduleCode", "regionBase", "yearList", "typeForm", "activeTab", "tabIndex", "reLoadChildABP", "accessLevels", "tabCode", "isLoadToJournalEnabled"],
    methods: {
        formatter(value) {
            return value.replace("-", "")
        },
        changeLevel() {
            if (this.level === 0) {
                this.accessLevels.position = 'abp';
            } else if (this.level === 1) {
                this.accessLevels.position = 'uf';
            }
        },
        async getAccessLevel() {
            this.loading = true;
            let abp = 0;
            let uo = 0;
            if (this.accessLevels?.operations !== undefined && this.accessLevels?.operations.length > 0) {
                this.accessLevels?.operations.forEach((op, ind) => {
                    if (op.toLowerCase().lastIndexOf('abp') !== -1) {
                        abp += 1;
                    }
                    if (op.toLowerCase().lastIndexOf('uf') !== -1) {
                        uo += 1;
                    }
                });
            }
            if (abp > 0) {
                this.levels.push({ value: 0, text: 'АБП' });
                this.accessLevels.position = 'abp'
                this.level = 0;
                if (uo > 0) { this.levels.push({ value: 1, text: 'УО' });}
            } else if (uo > 0) { this.level = 1;}

            this.loading = false;
        },
        findAndAssignAbp(abpCode) {
            if (this.abpBase && this.abpBase.length > 0) {
                const foundAbp = this.abpBase.find(abp => abp.abp === abpCode);
                if (foundAbp) {
                    this.currAbp = foundAbp;
                }
            }
        },
        findAndAssignRegion(regionCode) {
            if (this.regionBase && this.regionBase.length > 0) {
                const foundRegion = this.regionBase.find(region => region.code === regionCode);
                if (foundRegion) {
                    this.currRegion = foundRegion;
                }
            }
        },
        onBack(val, request) {
            this.newForm = val;
            this.findAndAssignRegion(request.region);
            this.findAndAssignAbp(request.abp);
            this.loadData(this.year, this.currRegion, this.currAbp);
            if (this.selectedAlteration !== null && this.selectedAlteration.code !== 'all') {
                this.requestsBase = this.requestsBase.filter((item) => item.requestType === this.selectedAlteration.code);
            }
            if (this.selectedStatus !== null && this.selectedStatus.code !== 0) {
                this.requestsBase = this.requestsBase.filter((item) => item.status.status === this.selectedStatus.code);
            }
        },
        onChange(val) {
            this.currentAlteration = val;
            this.modalConsolOpen(this.currentAlteration);
        },
        chgData(data) {
            try {
                this.requestsBase = data;
            } catch (error) {
                this.makeToast('danger', this.setText('warning'), this.setText('errors.param') + error.toString());
            }
        }, // обновление параметров
        onChecked(val) {
            this.cDis = !(val > 0);
        },
        onOpen(val) {
            this.currentAlteration = val;
            this.newForm = true;
        },
        onDelete(val) {
            if (val) {
                this.deleteRequest(val);
            }
        },
        onClose() {
            this.modalForm = false;
            if (this.currentAlteration.hasOwnProperty('oldDate')) {
                this.$set(this.currentAlteration, 'date', this.currentAlteration.oldDate);
            }
        },
        async modalConsolOpen(item) {
            if (item === null) {
                const res = await fetch(
                    "/api/budget-execution-alteration-uf-request/create-request-template?region=" + this.currRegion.code + "&planType=EXPENSE");
                const data = await res.json();

                this.currAltStatusEdit = false;
                this.currentAlteration = data;
                this.requestStatus = false;
            } else {
                this.currAltStatusEdit = true;
                const arr = {
                    id: item.id,
                    number: item.number,
                    gu: item.gu,
                    abp: item.abp,
                    date: item.date,
                    requestType: item.requestType,
                    description: item.description,
                    user_id: item.user_id,
                    level: item.level,
                    fileList: item.fileList,
                    status: item.status,
                    parent: item.parent
                };
                this.currentAlteration = arr;
                this.requestStatus = true;
            }
            this.saveFalse = false;
            this.currentAlteration.date = new Date(this.currentAlteration.date);
            // «Сконсолидировать» (справка УФ по расходам): дата — в пределах периода из фильтра этой вкладки (заявки АБП)
            if (!this.currAltStatusEdit) {
                this.currentAlteration.date = clampToPeriod(this.currentAlteration.date, this.dateFromForInput, this.dateToForInput);
            }
            this.curDate = new Date(this.currentAlteration.date);
            this.dateFrom = new Date(`${this.curDate.getFullYear()}-${this.curDate.getMonth() + 1}` + '-01');
            this.dateTo = new Date(`${this.curDate.getFullYear()}-${this.curDate.getMonth() + 1}-${new Date(this.curDate.getFullYear(), this.curDate.getMonth() + 1, 0).getDate()}`)
            if (this.currentAlteration.region === null) {
                this.currentAlteration.region = this.currRegion.code;
            }
            if (this.currentAlteration.user_id === null) {
                this.currentAlteration.user_id = this.userId;
            }
            this.selectedReqType = null;
            for (const item of this.requestTypeOptions) {
                if (item.code === this.currentAlteration.requestType) {
                    this.selectedReqType = item;
                }
            }
            this.createdAlterationFiles = [];
            for (const file of this.currentAlteration.fileList) {
                this.createdAlterationFiles.push({...file});
            }
            for (let i = 0; i < this.createdAlterationFiles.length; i++) {
                this.createdAlterationFiles[i].old = true;
            }
            this.currentAlteration.fileList = null;
            this.modalForm = true
        },
        reqTypeClick() {
            this.currentAlteration.requestType = this.selectedReqType.code;
        },
        async loadStatusList() {
            let response = [];
            try {
                response = await fetch('/api-py/get-full-status-list/' + this.mode);
                this.listStatus = await response.json();
                this.nameLocale(this.listStatus);
                if (localStorage[this.lsStatusFilter] !== undefined) {
                    this.listStatus.forEach((item) => {
                        if (item.code === parseInt(localStorage[this.lsStatusFilter])) {
                            this.selectedStatus = item;
                        }
                    });
                } else {
                    this.selectedStatus = this.listStatus[0];
                }
            } catch (error) {
                response = [];
                this.makeToast("danger", this.setText('errors.status'), error.toString());
            }
        },
        async loadAbpList() {
            let response = [];
            this.abpBase = [];
            response = await fetch('/api-py/user-abp-list/' + this.userId);
            const newBase = await response.json();
            this.abpBase = this.setIdArr(newBase, "abp");
            if (['uf'].includes(this.accessLevels.position)) {
                this.abpBase.push({
                    "name_ru": "Все",
                    "name_kk": "Барлығы",
                    "name_en": "All",
                    "abp": 0
                });
            }
            this.nameLocale(this.abpBase, 'abp');
            this.abpBase
                .sort((a, b) => (a.abp - b.abp > 0 ? 1 : -1));
        },
        setIdArr(arr, codeName) {
            const result = [];
            for (const el of arr) {
                if (
                    result.length > 0 &&
                    el[codeName] === result[result.length - 1][codeName]
                ) {
                    result[result.length - 1].idArr.push(el.id);
                } else {
                    result.push(Object.assign({ idArr: [el.id] }, el));
                }
            }
            return result;
        },
        roleIncludes(val){
            let ed = 0;
            if (this.accessLevels && this.accessLevels.operations) {
                this.accessLevels.operations.forEach((op, ind) => {
                    if (op.toLowerCase().lastIndexOf(val) !== -1) {
                        ed += 1;
                    }
                });
            }
            return ed > 0
        },
        async loadData(year, region, abp) {
            this.loading = true;
            let response = [];
            const dateFrom = this.dateFromForInput.toLocaleDateString().split('.').reverse().join('-');
            const dateTo = this.dateToForInput.toLocaleDateString().split('.').reverse().join('-');

            if ((year && region !== null && abp)) {
                try {
                    if (abp.abp !== 0) {
                        response = await fetch(
                            `/api/budget-execution-alteration-abp-request/list?region=${region.code}&dateBegin=${dateFrom}&dateEnd=${dateTo}&abp=${abp.abp}&level=${this.accessLevels.position.toUpperCase()}`
                        );
                    } else {
                        response = await fetch(
                            `/api/budget-execution-alteration-abp-request/list?region=${region.code}&dateBegin=${dateFrom}&dateEnd=${dateTo}&level=${this.accessLevels.position.toUpperCase()}`
                        );
                    }
                    // if (this.roleIncludes('abp_sign')) {
                    //     response = await fetch(
                    //         `/api/budget-execution-alteration-abp-request/list?dateBegin=${dateFrom}&dateEnd=${dateTo}&abp=${abp.abp}`
                    //     );
                    // }
                    response = await response.json();
                    this.getData(response);
                    this.loading = false;
                } catch (error) {
                    response = [];
                    this.loading = false;
                    this.makeToast(
                        "danger",
                        this.setText('errors.conclusion'),
                        error.toString()
                    );
                }
            }

        },
        filterDataByRegionAccess(data) {
            // Проверяем, есть ли заявки с АБП 123
            const hasAbp123 = data.some(item => item.abp === 123);

            // Если нет заявок с АБП 123, возвращаем исходный массив
            if (!hasAbp123) {
                return data;
            }

            // Проверяем наличие текущего региона для фильтрации
            if (!this.currRegion || !this.currRegion.code) {
                return data;
            }

            // Применяем фильтрацию по региону только к заявкам с АБП 123
            return data.filter(item => {
                // Если это не АБП 123, оставляем заявку без изменений
                if (item.abp !== 123) {
                    return true;
                }

                // Для АБП 123 применяем фильтрацию по региону в зависимости от уровня доступа
                if (['uf'].includes(this.accessLevels.position)) {
                    // Для пользователей УО фильтруем по полю region
                    return item.region === this.currRegion.code;
                } else if (['abp'].includes(this.accessLevels.position)) {
                    // Для пользователей АБП фильтруем по полю factRegion
                    console.log('this.factRegionSettings', this.factRegionSettings)
                    if (this.factRegionSettings) {
                        return item.factRegion === this.currRegion.code;
                    } else {
                        return item.region === this.currRegion.code;
                    }
                }

                // Для остальных ролей заявки АБП 123 проходят без фильтрации по региону
                return true;
            });
        },
        filterDataByAvailableAbp(data) {
            // Получаем список доступных АБП кодов из abpBase
            const availableAbpCodes = this.abpBase.map(item => item.code);
            // Фильтруем данные, оставляя только записи с АБП, которые есть в списке доступных
            return data.filter(item => availableAbpCodes.includes(item.abp));
        },
        getData(data) {
            this.loading = true;
            this.requestsBase = [];
            this.requestsData = [];
            // Последовательно применяем фильтры: по АБП, затем по региону, затем сортируем
            let filteredData = this.filterDataByAvailableAbp(data);
            filteredData = this.filterDataByRegionAccess(filteredData);

            this.requestsData = filteredData.sort((a, b) => b.create_date - a.create_date);

            this.requestsData.forEach((item, index) => {
                this.abpBase.forEach((row, ind) => {
                    if (row.abp === item.abp) {
                        this.$set(item, 'localText', row.localText);
                        this.$set(item, 'check', false);
                        if (item.status === null) {
                            this.$set(item, 'status', {status: item.statusList[item.statusList.length-1].status});
                        }
                    }
                });
                if ((['uf'].includes(this.accessLevels.position) && item.level === 'abp' && (item.status !== null && [32].includes(item.status.status)) && item.parent === null)) {
                    this.$set(item, 'checking', true);
                }
                else {
                    this.$set(item, 'checking', false);
                }
            });
            this.addUserName(this.requestsData);
            this.requestsBase = this.requestsData;
            if (this.selectedAlteration !== undefined && this.selectedAlteration.code !== 'all') {
                this.requestsBase = this.requestsBase.filter((item) => item.requestType === this.selectedAlteration.code);
            }
            if (this.selectedStatus !== null && this.selectedStatus.code !== 0) {
                this.requestsBase = this.requestsBase.filter((item) => item.status.status === this.selectedStatus.code);
            }
            if (this.typeForm > 0) {
                this.requestsBase = this.requestsBase.filter((item) => item.requestType !== 'individual');
                if (this.accessLevels.position === "uf") {
                    this.requestsBase = this.requestsBase.filter((item) => ![1].includes(item.status.status));
                }
            } else {
                this.requestsBase = this.requestsBase.filter((item) => item.requestType === 'individual');
            }
            this.loading = false;
        },
        addUserName(data) {
            const userIdList = [];
            data.forEach((item) => {userIdList.push(item.user_id);});
            const unicUserIdList = [...new Set(userIdList)];
            this.loadUsers(unicUserIdList);
        },
        async loadUsers(arr) {
            try {
                for (const item of arr) {
                    const response = await fetch('/api-py/get-realm-user/' + item);
                    const currUser = await response.json();
                    if (currUser !== undefined){
                        this.userList.push(currUser);
                    }
                }
                this.getUsers();
            } catch (error) {
                this.makeToast('danger', this.setText('errors.users'), error.toString());
            }
        },
        getUsers() {
            if (!this.requestsBase) return;
            this.requestsBase.forEach((item) => {
                this.userList.map((user) => {
                    if ((user !== null) && (user.id === item.user_id)) {
                        const userName = `${user.firstName} ${user.lastName}`;
                        this.$set(item, "userName", userName);
                    }
                });
            });
        },
        clearParam() {
            this.currRegion = null;
            this.currAbp = null;
            this.year = `${new Date().getFullYear()}`;

        },
        makeToast(variant, title, tostbody) {
            this.$bvToast.toast(tostbody, {
                title: title,
                variant: variant,
                toaster: 'b-toaster-top-center',
                autoHideDelay: 5000,
                appendToast: true
            });
        }, // сообщение
        openFilterByRef(refName) {
            const drop = this.$refs.drop;
            drop.show(true);
            this.$emit('openFilterByRef', refName);
            let refItem;
            switch (refName) {
                case 'filterYear':
                    refItem = this.$refs.filterYear;
                    break;
                case 'filterAbp':
                    refItem = this.$refs.filterAbp;
                    break;
                case 'filterReg':
                    refItem = this.$refs.filterReg;
                    break;
                case 'refAlteration':
                    refItem = this.$refs.refAlteration;
                    break;
                case 'refStatus':
                    refItem = this.$refs.refStatus;
                    break;
                default: break;
            }
            setTimeout(() => refItem.$el.focus(), 100);
        },
        reset: function() {
            this.deletedAlterationFiles = [];
            this.loadData(this.year, this.currRegion, this.currAbp);
        },
        async saveRequest() {
            this.saveTrue = false;
            this.cDis = true;

            // При редактировании в специальном режиме (только поле "Основание") проверяем только описание
            if (this.requestStatus && this.canEditBasisField) {
                if (this.currentAlteration.description !== null && this.currentAlteration.description !== '') {
                    this.loading = true;
                    await this.svRequest();
                } else {
                    this.saveTrue = true;
                }
            }
            // Стандартная проверка для создания новой заявки или полного редактирования
            else if (this.currentAlteration.description !== null && this.currentAlteration.requestType !== null && this.currentAlteration.number !== '') {
                this.loading = true;
                await this.svRequest();
            } else {
                this.saveTrue = true;
            }
        },
        syncFile: function (e) {
            e.preventDefault();
            this.createdAlterationFiles.push(e.target.files[0]);
            const files = document.getElementById('fileInput').value;
        },
        async svRequest() {
            this.currentAlteration.date = this.currentAlteration.date.getTime();
            const res = await fetch(this.accessLevels.position === 'abp'? "/api/budget-execution-alteration-abp-request" : "/api/budget-execution-alteration-uf-request",
                {
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    method: this.currentAlteration.id ? "PUT" : "POST",
                    body: JSON.stringify(this.currentAlteration)
                })
                .then(response => {
                    if (response.status === 200) {
                        response.json().then(async json => {
                            const isEditMode = this.requestStatus; // Сохраняем состояние до обновления объекта
                            this.currentAlteration = json;
                            if (!this.currentAlteration.status) {
                                this.$set(this.currentAlteration, "status", []);
                                if (!this.currentAlteration.status.status) {
                                    this.$set(this.currentAlteration.status, "status", 1);
                                }
                            }

                            // Вызываем переключение вкладок только если это создание НОВОЙ заявки
                            if (!isEditMode) {
                                if (this.accessLevels.position === 'abp') {
                                    this.$emit('referencesABPActive', this.currentAlteration);
                                } else {
                                    this.$emit('applicationsABPActive', this.currentAlteration);
                                }
                            }

                            for (let i = 0; i < this.createdAlterationFiles.length; i++) {
                                if (!this.createdAlterationFiles[i].old) {
                                    await this.saveFile(json.id, this.createdAlterationFiles[i])
                                }
                            }
                            for (let i = 0; i < this.deletedAlterationFiles.length; i++) {
                                await this.deleteFile(this.deletedAlterationFiles[i].id, this.deletedAlterationFiles[i])
                            }
                            // Добавить заявку Гу в заявку Абп
                            for (let i = 0; i < this.requestsBase.length; i++) {
                                if (this.requestsBase[i].check) {
                                    await this.saveGuRequest(json.id, this.requestsBase[i].id);
                                    this.requestsBase[i].check = false;
                                }
                            }
                            this.reset();
                            this.loading = false;

                            // Закрываем форму (возвращаемся к списку) только при создании новой записи
                            if (this.accessLevels.position !== 'abp' && !isEditMode) {
                                this.newForm = false;
                                this.saveFalse = false;
                            }

                            if (isEditMode) {
                                this.makeToast('success', this.setText('message'), this.setText('data_saved'));
                            }
                        });
                        this.modalForm = false;
                    } else {
                        this.loading = false;
                    }
                    if (response.status === 500) {
                        response.json().then(async json => {
                            if (json.key === 'modules.budgetExecutionAlteration.error.requestNumberAlreadyExists') {
                                this.saveFalse = true;
                                this.loading = false;
                            }
                            this.currentAlteration.date = new Date(this.currentAlteration.date);
                        })
                    }
                })
        },
        deleteRequest(item) {
            this.$bvModal.msgBoxConfirm(
                this.setText('delete_confirm'),
                {
                    title: this.setText('confirmation'),
                    size: 'lg',
                    buttonSize: 'sm',
                    okVariant: 'success',
                    okTitle: this.setText('yes'),
                    cancelTitle: this.setText('canc'),
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(value => {
                    if (value) {
                        this.deleteReq(item);
                    }
                })
                .catch(error => {
                    this.makeToast('danger', this.setText('errors.delete'), error.toString());
                });
        },
        async deleteReq(item){
            const result = await fetch("/api/budget-execution-alteration-abp-request?requestId=" + item.id, {
                method: "DELETE",
            });
            if (result.status === 200) {
                const ind1 = this.requestsData.indexOf(item);
                this.requestsData.splice(ind1, 1);

                const ind2 = this.requestsBase.indexOf(item);
                this.requestsBase.splice(ind2, 1);
            } else {
                const res = await result.json();
                // Функция для обработки ошибки handleAbpCheckError
                const handleAbpCheckError = (args) => {
                    let numReq = null;
                    let numDate = null;

                    args.forEach(({type, value}) => {
                        if (type === 'number') numReq = value;
                        if (type === 'date') numDate = value;
                    });
                    const formattedDate = new Date(numDate).toISOString().split('T')[0];
                    this.makeToast('danger', this.setText('message'), this.setText('notdelete') + numReq + this.setText('notdeletefrom') + formattedDate + this.setText('notdeleteend'));
                };
                switch (res.key) {
                    case 'modules.budgetExecutionAlteration.error.requestHistoryAbpCheck':
                        handleAbpCheckError(res.args);
                        break;

                    case 'modules.budgetExecutionAlteration.error.requestSentISKK':
                        this.makeToast('danger', this.setText('message'), this.setText('errors.requestSentISKK'));
                        break;

                    default:
                        this.makeToast('danger', this.setText('message'), this.setText('errors.delete'));
                        break;
                }
            }
            setTimeout(() => this.$emit('reLoad', true), 1000);
        },
        saveFile: async function (id, file) {
            const data = new FormData();
            data.append("file", file);
            return await fetch("/api/budget-execution-alteration-request/file?requestId=" + id,
                {
                    method: "POST",
                    body: data
                })
                .then(response => {
                })
                .catch(error => {
                    alert("Error!");
                    console.log(error);
                });
        },
        onReLoad(val){ this.$emit('reLoad', val); },
        saveGuRequest: async function (requestId, guRequestId) {
            // const params = { guRequestId: guRequestId, requestId: requestId }
            return await fetch(`/api/budget-execution-alteration-uf-request/add-gu-request?guRequestId=${guRequestId}&requestId=${requestId}`,
                {
                    method: "POST"
                })
                .then(response => {
                })
                .catch(error => {
                    alert("Error!");
                    console.log(error);
                });
        },
        deleteFile: async function (id) {
            return await fetch("/api/budget-execution-alteration-request/file?fileId=" + id,
                {
                    method: "DELETE",
                })
        },
        altRefAbp(val) {
            this.currentAlteration = val;
            this.setCurrAbp(this.currentAlteration.abp);
            this.newForm = true;
        },
        altAllAbp(val) {
            this.currentAlteration = val;
            this.setCurrAbp(this.currentAlteration.abp);
            this.newForm = true;
        },
        typeListLoad() {
            this.requestTypeList.splice(0);
            this.listAlteration.splice(0);
            this.listAlteration.push({code: 'all', name_ru: 'Все', name_kk: 'Барлығы', name_en: 'All'});
            if (['uf'].includes(this.accessLevels.position)) {
                if (this.requestTypeOptions && this.requestTypeOptions.length > 0) {
                    this.requestTypeOptions.forEach((item) => {
                        if (!['individual', 'budget_income', 'budget_income_clarification', 'budget_income_movement'].includes(item.code)) {
                            this.requestTypeList.push(item);
                            this.listAlteration.push(item);
                        }
                    });
                }
            }
            if (['abp'].includes(this.accessLevels.position)) {
                if (this.typeForm === 0) {
                    if (this.requestTypeOptions && this.requestTypeOptions.length > 0) {
                        this.requestTypeOptions.forEach((item) => {
                            if (['individual'].includes(item.code)) {
                                this.listAlteration.push(item);
                            }
                            if (!['budget_income', 'budget_income_clarification', 'budget_income_movement'].includes(item.code)) {
                                this.requestTypeList.push(item);
                            }
                        });
                    }
                } else {
                    if (this.requestTypeOptions && this.requestTypeOptions.length > 0) {
                        this.requestTypeOptions.forEach((item) => {
                            if (['movement', 'budget_clarification', 'budget_adjustment'].includes(item.code)) {
                                this.listAlteration.push(item);
                            }
                            if (!['budget_income', 'budget_income_clarification', 'budget_income_movement'].includes(item.code)) {
                                this.requestTypeList.push(item);
                            }
                        });
                    }
                }
            }
            this.nameLocale(this.requestTypeList);
            this.nameLocale(this.listAlteration);
        },
        keyPress: function (event, pattern) {
            const regex = new RegExp(pattern);
            const key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
            if (!regex.test(key)) {
                event.preventDefault();
                return false;
            }
            this.saveFalse = false
        }, // ввод по заданному паттерну,
        dateChange(){
            if (this.currAltStatusEdit){
                if (this.curDate >= this.dateFrom && this.curDate <= this.dateTo) {
                    this.$set(this.currentAlteration, 'oldDate', this.currentAlteration.date);
                    this.currentAlteration.date = this.curDate;
                } else {
                    this.curDate = this.currentAlteration.date;
                }
            } else { this.currentAlteration.date = this.curDate; }
        },
        // при «Сконсолидировать» можно выбрать только дату в пределах периода из фильтра
        createDateDisabled(date) {
            return !this.currAltStatusEdit && isOutOfPeriod(date, this.dateFromForInput, this.dateToForInput);
        },
        filterApply(){
            if (this.requestsData !== null) {
                if (this.accessLevels.position === "abp") {
                    if (this.typeForm === 0) {
                        this.requestsBase = this.requestsData.filter((item) => item.requestType === 'individual'); //(![1].includes(item.status.status) || ([1].includes(item.status.status) && item.user_id === store.state.user.sub)) &&
                    } else {
                        this.requestsBase = this.requestsData.filter((item) => item.requestType !== 'individual'); //(![1].includes(item.status.status) || ([1].includes(item.status.status) && item.user_id === store.state.user.sub)) &&
                    }
                }
                if (this.accessLevels.position === "uf") {
                    this.requestsBase = this.requestsData.filter((item) => (![1].includes(item.status.status) || ([1].includes(item.status.status) && item.user_id === store.state.user.sub)) && item.requestType !== 'individual');
                }
                if (this.selectedAlteration !== null && this.selectedAlteration.code !== 'all') {
                    this.requestsBase = this.requestsBase.filter((item) => item.requestType === this.selectedAlteration.code);
                }
                if (this.selectedStatus !== null && this.selectedStatus.code !== 0) {
                    this.requestsBase = this.requestsBase.filter((item) => item.status.status === this.selectedStatus.code);
                }
            }
        },
        clearFilter(){
            this.selectedAlteration = this.listAlteration[0];
            this.selectedStatus = this.listStatus[0];
            if (this.accessLevels.position === "abp") {
                if (this.typeForm === 0) {
                    this.requestsBase = this.requestsData.filter((item) => item.requestType === 'individual'); //(![1].includes(item.status.status) || ([1].includes(item.status.status) && item.user_id === store.state.user.sub)) &&
                } else {
                    this.requestsBase = this.requestsData.filter((item) => item.requestType !== 'individual'); //(![1].includes(item.status.status) || ([1].includes(item.status.status) && item.user_id === store.state.user.sub)) &&
                }
            }
            if (this.accessLevels.position === "uf") {
                this.requestsBase = this.requestsData.filter((item) => (![1].includes(item.status.status) || ([1].includes(item.status.status) && item.user_id === store.state.user.sub)) && item.requestType !== 'individual');
            }
        },
        async intgrSettingsLoad(){
            this.intgrSettings = await this.loadSettings('intgr');
        },
        findAbpByCode(abpCode) {
            // Поиск по коду АБП
            const found = this.abpBase.find(item => item.abp === abpCode);
            return found || null;
        },
        setCurrAbp(abpCode) {
            const abp = this.findAbpByCode(abpCode);
            if (abp) {
                this.currAbp = abp;
                this.loadData(this.year, this.currRegion, this.currAbp);
            } else {
                this.currAbp = this.abpBase[0] || null;
            }
        },
        async factRegionSettingsLoad(){
            this.factRegionSettings = await this.loadSettings('fact_region');
        }

    },
    filters: {
        formatDate: function (value) {
            if (value) {
                const date = new Date(value);
                return date.toLocaleDateString();
            }
            return null;
        }
    }
};
</script>

<style lang="scss" scoped>
.content {
    display: flex;
    gap: 20px;
    background-color: #eef1f8;
    justify-content: space-between;
}

.content {
    height: 100%;
    .title {
        font-weight: 700;
        font-size: 14px;
        text-transform: uppercase;
        padding-left: 20px;
        margin-bottom: 26px;
    }
    .constructor,
    .forms {
        flex: 1;
    }

    .body {
        background-color: #f7f9fc;
    }

    .item {
        display: flex;
        align-items: center;
        height: 48px;
        border: 1px solid #d3dbe3;
        justify-content: space-between;
        padding: 0px 10px 0px 16px;

        &__title {
            font-weight: 500;
            font-size: 14px;
            color: #6087a0;
        }
    }

    .multiselect {
        max-width: 400px;
    }

    .footer {
        display: flex;
        height: 48px;
        align-items: center;
        justify-content: end;
        border: 1px solid #d3dbe3;
        border-top: 0;
        padding-right: 40.5%;
    }

    .vertical-line {
        width: 1px;
        background-color: #d3dbe3;
        margin-top: 40px;
    }
}
.add_modal {
    width:100%;
    height:100%;
    &__body {
        background-color: #f7f9fc;
        border: 1px solid #d3dbe3;
        border-radius: 5px;
        margin-bottom: 23px;
    }

    &__title {
        font-weight: 600;
        font-size: 14px;
        margin-bottom: 26px;
    }

    &__item {
        display: flex;
        align-items: center;
        height: 50px;
        border: 1px solid #d3dbe3;
        justify-content: space-between;
        padding: 0px 10px 0px 16px;

        &__title {
            font-weight: 500;
            font-size: 14px;
            color: #6087a0;
        }
    }

    .input-file {
        font-weight: 600;
        font-size: 14px;
        color: #6087a0;
        &-label {
            width: 400px;
            font-weight: 600;
            font-size: 14px;
            color: #6087a0;
            cursor: pointer;
            display: flex;
            justify-self: flex-start;
        }
    }
    .form-file {
        font-weight: 600;
        font-size: 14px;
        color: #6087a0;
    }
}
.button {
    border: none;
    border-radius: 10px;
}

.button-close {
    color: red;
}
.second-modal {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 26px;
    &__title {
        font-weight: 500;
        font-size: 14px;
    }
}

.date-picker-container {
    display: flex;
    gap: 79px;
    align-items: center;
    font-weight: 500;
    font-size: 14px;
    line-height: 19px;
    color: #6087a0;

    input[type="number"] {
        border: 1px solid #bcd2e0;
        border-radius: 5px;
        padding-right: 5px;
        max-width: 80px;
        height: 28px;
        text-indent: 7px;
        text-align: left;
    }
}
.requests-count {
    margin-top: 10px;
    font-weight: bold;
    color: #6087a0;
    font-size: 12px;
}
</style>